/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { useNavigate, useLocation } from "react-router-dom";
import { empty, isArray, prepareResponseData } from "../../Utilities/utils";

// css
import "../schools/Schools.css";

// api
import subscriptionApi from "../../api/Subscription";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import { AuthContext } from "../Root/ProtectedRoute";
import TableLoading from "../../components/skeleton/TableLoading";
import SubscriptionsWrapper from "../../components/appWrapper/SubscriptionsWrapper";
import SubscriptionPackagesTable from "../../components/tables/primeTable/subscriptions/SubscriptionPackagesTable";

const SubscriptionPackages = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  //ref
  const toastTR = useRef(null);
  // states
  const [packageData, setPackageData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [search, setSearch] = useState("");
  const [blur, blurChange] = useState("");

  //alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR.current.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (!empty(location) && !empty(location.state)) {
      const paramState = !empty(location.state) ? location.state : {};
      let dataAdded = !empty(paramState.dataAdded)
        ? paramState.dataAdded
        : false;
      let dataUpdated = !empty(paramState.dataUpdated)
        ? paramState.dataUpdated
        : false;
      let dataDeleted = !empty(paramState.dataDeleted)
        ? paramState.dataDeleted
        : false;
      if (
        dataAdded === true ||
        dataUpdated === true ||
        dataDeleted === true
      ) {
        const actionType = dataAdded
          ? "added"
          : dataUpdated
          ? "updated"
          : dataDeleted
          ? "deleted"
          : "";
        paramState.dataAdded = false;
        paramState.dataUpdated = false;
        paramState.dataDeleted = false;
        responseDialog(
          "success",
          "Success",
          `Package ${actionType} successfully!`
        );
        if (!empty(location) && !empty(location.state)) {
          navigate(null, {
            replace: true,
            state: {
              dataAdded: false,
              dataUpdated: false,
              dataDeleted: false,
            },
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    // fetch subscription package data
    getSubscriptionPackages();
  }, [first, rows, blur, user]);

  async function getSubscriptionPackages() {
    try {
      const page = first / rows;
      const response = await subscriptionApi.getSubscriptionPackages(page, rows, search);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? response_data.response
            : "Something went wrong!"
        );
      }
      setTotalRecords(!empty(response_data.count) ? response_data.count : 0);
      setPackageData(isArray(response_data?.response) ? response_data.response : []);
    } catch (error) {
      return responseDialog("error", error?.code === 'ERR_NETWORK' ? 'Network Error' : "Error Alert!", error?.message || "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  }

  //go to update school page
  const gotToUpdatePackage = (data) => {
    const packageId = !empty(data) && !empty(data._id) ? data._id : "";
    if (!empty(packageId)) {
      return navigate(`/subscription-package/${packageId}/update`);
    }

    return;
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  const onSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const onBlurChange = (event) => {
    blurChange(event.target.value);
    setFirst(0);
  };

  return (
    <>
      <SubscriptionsWrapper {...props}>
        <main>
          <div className="tableCard">
            {/*  header start */}
            <MainHeader
              button
              buttonText="Add Package"
              link="/subscription-package-add"
              title="Subscription Packages"
            />
            {/* end of header */}

            {/* table start */}
            {!isLoading ? (
              <SubscriptionPackagesTable
                packages={packageData}
                goToUpdatePackageScreen={gotToUpdatePackage}
                onPageChange={onPageChange}
                loading={isLoading}
                rows={rows}
                totalRecords={totalRecords}
                first={first}
                search={search}
                onSearchChange={onSearchChange}
                onSearchBlur={onBlurChange}
              />
            ) : (
              <TableLoading cols={6} />
            )}
            {/* table end  */}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </SubscriptionsWrapper>
    </>
  );
};

export default SubscriptionPackages;
